module.exports = __webpack_public_path__ + "img/corredor1.1abf7737.jpg";